module.exports = __webpack_public_path__ + "img/tips.90a4aba5.svg";